export default "__VITE_ASSET__0d763d68__"